import { useNavigate } from 'react-router-dom';
import { setFyersCredentials, triggerFyersLogin } from '../services/fyersAuth';

function FyersLoginPage() {
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const clientId = formData.get('clientId')?.toString().trim() || '';
    const secretKey = formData.get('secretKey')?.toString().trim() || '';
    const pin = formData.get('pin')?.toString().trim() || '';
    const redirectUri = `${window.location.origin}/fyers/callback`;

    setFyersCredentials(clientId, secretKey, redirectUri, pin);
    triggerFyersLogin();
  };

  return (
    <div className="login-shell">
      <div className="login-panel">
        <div className="brand-block">
          <p className="eyebrow">Broker Authentication</p>
          <h1>Reconnect Fyers before using admin trading controls</h1>
          <p className="supporting-text">
            The admin dashboard uses the same Fyers validation flow as the main UI. If the
            broker token is missing or expired, complete this step to continue.
          </p>
        </div>

        <form className="login-card" onSubmit={handleSubmit}>
          <h2>Fyers Login</h2>
          <label>
            Client ID
            <input name="clientId" type="text" placeholder="Enter Fyers client ID" required />
          </label>
          <label>
            Secret Key
            <input name="secretKey" type="password" placeholder="Enter Fyers secret key" required />
          </label>
          <label>
            PIN
            <input name="pin" type="password" placeholder="Enter Fyers PIN" required />
          </label>
          <button type="submit" className="primary-button">
            Continue with Fyers
          </button>
          <button type="button" className="ghost-button" onClick={() => navigate('/', { replace: true })}>
            Back to dashboard
          </button>
        </form>
      </div>
    </div>
  );
}

export default FyersLoginPage;
